import Vue from 'vue';
import Vuex from 'vuex';
import tournament from '@/store/modules/tournament';
import achievements from '@/store/modules/achievements';
import freeSpins from '@/store/modules/freeSpins';
import settings from '@/store/modules/settings';
import otherData from '@/store/modules/otherData';
import freeRounds from '@/store/modules/freeRounds';
import freeBets from '@/store/modules/freeBets';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { tournament, achievements, freeSpins, otherData, settings, freeRounds, freeBets }
});
